const checkPhotoCountEnabled = services => {
  return services?.some(service => service?.photoCountEnabled);
};

module.exports = {
  checkPhotoCountEnabled,
};
